export const EVENT_TYPES = {
  CELEBRATIONS: 'Festejos',
  MY_DAY: 'Mi día',
  OTHERS: 'Otros',
};
